import { render, staticRenderFns } from "./ArmsBaseArchiveCategory.vue?vue&type=template&id=d7dcf3aa&scoped=true&"
import script from "./ArmsBaseArchiveCategory.vue?vue&type=script&lang=js&"
export * from "./ArmsBaseArchiveCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7dcf3aa",
  null
  
)

export default component.exports